import { Grid } from "antd";
import { withConditionalComponent } from "src/HOC";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import GuestsSelectionWeb from "./layouts/GuestsSelection.web";
import GuestsSelectionMob from "./layouts/GuestsSelection.mob";
import { useTranslation } from "react-i18next";

const GuestsSelectionComponent = withConditionalComponent(GuestsSelectionWeb, GuestsSelectionMob);

export default function GuestsSelection() {
  const isLargeScreen = Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];
  const {t} = useTranslation();
  const label = t("Hotels.search.roomsAndGuestsLabel");
  
  return <GuestsSelectionComponent trigger={isLargeScreen} props={{ label }} />;
}
